module.exports = __webpack_public_path__ + "static/img/buka.c847b56e.png";